import React, { Component } from "react";
import firebase from "../../utils/firebase";

import Button from "@atlaskit/button";
import EditorRemoveIcon from "@atlaskit/icon/glyph/editor/remove";

import "./profileFormEmploymentCard.css";
export default class ProfileFormEmploymentCard extends Component {
  handleDeleteEmploymentClick = () =>
    firebase
      .firestore()
      .collection("my")
      .doc(this.props.userContext.user.uid)
      .update({
        [`${this.props.type.toLowerCase()}Employment`]: firebase.firestore.FieldValue.delete()
      });

  render() {
    return (
      <div className="profile-employment-card profile-card">
        <h6 className="profile-employment-card__detail">
          {`${this.props.type} Employment`}
        </h6>
        <p className="profile-employment-card__detail">
          {this.props.employment.position} at {this.props.employment.employer},{" "}
          {this.props.employment.employmentLength}
        </p>
        <p className="profile-employment-card__detail">
          {this.props.employment.supervisor},{" "}
          {this.props.employment.businessAddress}
        </p>
        <p className="profile-employment-card__detail">
          {this.props.employment.businessPhone}
        </p>
        {this.props.employment.monthlySalary && (
          <p className="profile-employment-card__detail">
            {this.props.employment.monthlySalary}
          </p>
        )}

        <Button
          iconBefore={<EditorRemoveIcon />}
          onClick={this.handleDeleteEmploymentClick}
        >
          Delete
        </Button>
      </div>
    );
  }
}

ProfileFormEmploymentCard.defaultProps = {
  type: "",
  employment: {}
};



// WEBPACK FOOTER //
// ./src/components/profileFormEmploymentCard/ProfileFormEmploymentCard.js